import { Typography } from "antd";
import React from "react";

const { Text } = Typography;

interface IHighlightValueProps {
    highlightValues: IHighlightValue[];
}

export default function HighlightValue({ highlightValues }: IHighlightValueProps) {
    return (
        <div className="flex flex-col gap-2">
            {highlightValues.map((value, index) => {
                let highlightKey = String(Object.keys(value)[0]);
                let highlightValue = String(Object.values(value)[0]);

                if (highlightValue && highlightValue.trim()) {
                    let hightlightComponents = [];
                    let text = "";
                    for (let i = 0; i < highlightValue.length; i++) {
                        if (highlightValue.substring(i, i + 4) === "<em>") {
                            if (text) {
                                hightlightComponents.push(<Text>{text}</Text>);
                            }
                            text = "";
                            i = i + 4 - 1;
                        } else if (highlightValue.substring(i, i + 5) === "</em>") {
                            if (text) {
                                hightlightComponents.push(<Text mark>{text}</Text>);
                            }
                            text = "";
                            i = i + 5 - 1;
                        } else {
                            text = text + highlightValue[i];
                        }
                    }

                    if (text) {
                        hightlightComponents.push(<Text>{text}</Text>);
                    }

                    if (hightlightComponents.length > 0) {
                        return (
                            <div key={`${highlightKey}_${index}`} className="flex flex-row flex-wrap gap-1">
                                <Text strong underline>
                                    {highlightKey}:
                                </Text>
                                <div className="flex flex-wrap">
                                    {hightlightComponents.map((hl, i) => (
                                        <React.Fragment key={`${highlightKey}-${index}-${i}`}>{hl}</React.Fragment>
                                    ))}
                                </div>
                            </div>
                        );
                    }
                }

                return (
                    <div className="flex flex-row flex-wrap gap-1" key={`${highlightKey}_${index}`}>
                        <Text strong underline>
                            {highlightKey}:
                        </Text>
                        {highlightValue.trim() ? (
                            <Text>{highlightValue}</Text>
                        ) : (
                            <Text italic className="text-gray-500">
                                blank
                            </Text>
                        )}
                    </div>
                );
            })}
        </div>
    );
}
